// extracted by mini-css-extract-plugin
export var md = "_1f-4";
export var semantic = "_1f-5";
export var sm = "_1f-3";
export var text = "_1f-6";
export var toggleInput = "_1f-0";
export var toggleSwitch = "_1f-1";
export var xs = "_1f-2";